import { useState } from "react";
import { useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";
import axios from "../../utils/axios";
import Button from "../Button";
import Input from "../Input";
import { validateEmail, validateName } from "../../utils/validators";
import { XANO_API_BASE_URL } from "../../utils/api-urls";
import { DASHBOARD } from "../../utils/routes";
import "./styles.scss";

const Signup = (props: any) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");

  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [companyNameError, setCompanyNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isEmailvalid, setIsEmailValid] = useState(false);

  const [otpSent, setOtpSent] = useState(false);

  const [waitOnSendOtp, setWaitOnSendOtp] = useState(false);
  const [waitOnSubmit, setWaitOnSubmit] = useState(false);

  const [sendOtpError, setSendOtpError] = useState("");
  const [submitError, setSubmitError] = useState("");

  const navigate = useNavigate();

  const handleFirstName = (firstName: string) => {
    setFirstName(firstName);
    if (!firstName) {
      setFirstNameError("First Name cannot be empty");
    } else if (!validateName(firstName)) {
      setFirstNameError("First Name should only consists of letters and space");
    } else {
      setFirstNameError("");
    }
  };

  const handleLastName = (lastName: string) => {
    setLastName(lastName);
    if (!lastName) {
      setLastNameError("Last Name cannot be empty");
    } else if (!validateName(lastName)) {
      setLastNameError("Last Name should only consists of letters and space");
    } else {
      setLastNameError("");
    }
  };

  const handleCompanyName = (companyName: string) => {
    setCompanyName(companyName);
    if (!companyName) {
      setCompanyNameError("Company Name cannot be empty");
    } else if (!validateName(companyName)) {
      setCompanyNameError(
        "Company Name should only consists of letters and space"
      );
    } else {
      setCompanyNameError("");
    }
  };

  const handleEmail = (email: string) => {
    setEmail(email);

    if (!email) {
      setEmailError("Email cannot be empty");
      setIsEmailValid(false);
    } else if (!validateEmail(email)) {
      setEmailError("Enter a vaild email address");
      setIsEmailValid(false);
    } else {
      setEmailError("");
      setIsEmailValid(true);
    }
  };

  const handleOtp = (otp: string) => {
    setOtp(otp);
  };

  const handleSendOTP = async () => {
    setWaitOnSendOtp(true);
    setSendOtpError("");
    try {
      const otpSentResponse: any = await axios.post(
        `${XANO_API_BASE_URL}/emp_prefs/generate_OTP?newEmployee=true`,
        {
          email: email,
          subject: "OTP for Registration",
          body: `Dear Recruiter, <br/><br/> Please use the OTP <b><OTP></b> for your account registration <br/> <br/> Regards,<br> Team Hiringhood`,
        }
      );
      if (otpSentResponse?.data) {
        setOtpSent(true);
        setWaitOnSendOtp(false);
        setSendOtpError("");
      }
    } catch (err: any) {
      setWaitOnSendOtp(false);
      const { response } = err;
      const { data } = response;
      if (data && data.message === "EMPLOYER_ALREADY_EXISTS") {
        setSendOtpError(
          `A user already exists with the email address ${email}. Please login to continue`
        );
      } else {
        setSendOtpError(
          "There was an error while trying to send an OTP to your email address. Please try again later"
        );
      }
    }
  };

  const handleSubmit = async () => {
    setWaitOnSubmit(true);
    setSubmitError("");
    try {
      const registerResponse: any = await axios.post(
        `${XANO_API_BASE_URL}/emp_prefs/register_employer`,
        {
          firstName,
          lastName,
          email,
          OTP: otp,
          company: companyName,
        }
      );
      if (registerResponse?.data) {
        setWaitOnSubmit(false);
        const { data } = registerResponse;
        const employerData = {
          id: data["employer_id"],
          company: data["Company_Name"],
          name: `${data["First_Name"]} ${data["Last_Name"]}`,
          email: data["email"],
        };
        localStorage.setItem("employerData", JSON.stringify(employerData));
        navigate(DASHBOARD);
      }
    } catch (err: any) {
      const { response } = err;
      const { data } = response;
      setWaitOnSubmit(false);
      if (data && data.message === "EMPLOYER_ALREADY_EXISTS") {
        setSubmitError(`A user already exists with the email address ${email}`);
      } else {
        setSubmitError(
          "There was an error during registration. Please try again later"
        );
      }
    }
  };

  return (
    <>
      <div className="signup-text-field-container">
        <Input
          className="signup-input"
          label="First Name*"
          value={firstName}
          onChange={(event) => {
            handleFirstName(event?.target.value);
          }}
          onBlur={(event) => {
            handleFirstName(event?.target.value);
          }}
        />
      </div>
      <div className="signup-text-field-container">
        <Input
          className="signup-input"
          label="Last Name*"
          value={lastName}
          onChange={(event) => {
            handleLastName(event?.target.value);
          }}
          onBlur={(event) => {
            handleLastName(event?.target.value);
          }}
        />
      </div>
      <div className="signup-text-field-container">
        <Input
          className="signup-input"
          label="Company Name*"
          value={companyName}
          onChange={(event) => {
            handleCompanyName(event?.target.value);
          }}
          onBlur={(event) => {
            handleCompanyName(event?.target.value);
          }}
        />
      </div>
      <>
        {!otpSent && (
          <>
            <div className="signup-email-container">
              <Input
                className="signup-email"
                label="Email Address*"
                value={email}
                onChange={(event) => {
                  handleEmail(event.target.value);
                }}
                onBlur={(event) => {
                  handleEmail(event?.target.value);
                }}
                disabled={waitOnSendOtp}
              />
              <div className="signup-send-otp-container">
                <Button
                  className="signup-send-otp"
                  label="Send OTP"
                  disabled={!isEmailvalid || waitOnSendOtp}
                  onClick={handleSendOTP}
                  loading={waitOnSendOtp}
                />
              </div>
            </div>
            <p className="signup-error">
              {firstNameError ||
                lastNameError ||
                companyNameError ||
                emailError ||
                sendOtpError}
            </p>
          </>
        )}
      </>
      {otpSent && (
        <>
          <p className="signup-enter-otp">{`Enter the OTP received on your email address: ${email}`}</p>
          <div className="signup-email-container">
            <OtpInput
              shouldAutoFocus
              numInputs={4}
              isInputNum
              inputStyle={"signup-otp-input"}
              onChange={handleOtp}
              value={otp}
            />
          </div>
          <p className="signup-error">
            {firstNameError ||
              lastNameError ||
              companyNameError ||
              emailError ||
              sendOtpError}
          </p>
        </>
      )}
      <div className="signup-submit-container">
        <Button
          label="Submit"
          className="signup-submit"
          disabled={
            firstNameError.length > 0 ||
            lastNameError.length > 0 ||
            companyNameError.length > 0 ||
            !(otp.length === 4)
          }
          onClick={handleSubmit}
          loading={waitOnSubmit}
        />
      </div>
      {submitError && <p className="signup-error">{submitError}</p>}
    </>
  );
};

export default Signup;
